/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'cardType': GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum];


